const translations: Record<string, Record<string, string>> = {
  'zh-tw': {
    'optionalItem.1.title': 'Pamo 法律支援',
    'optionalItem.2.title': '退訂安心保障',
    // Payment method 相關
    'paymentMethod.CREDIT_CARD': '信用卡',
    'paymentMethod.DEBIT_CARD': '金融卡',
    'paymentMethod.LINE_PAY': 'LINE Pay',
    'paymentMethod.AFTEE': 'Aftee',
    'paymentMethod.CASH': '現金',
    // Car equipment 相關
    'car.equipment.GPS': 'GPS導航',
    'car.equipment.ETC': 'ETC',
    'car.equipment.CD_PLAYER': 'CD播放器',
    'car.equipment.ADVANCED_AUDIO': '高級音響',
    'car.equipment.AUX': 'AUX音源孔',
    'car.equipment.USB': 'USB接孔',
    'car.equipment.BLUETOOTH': '藍芽',
    'car.equipment.CARPLAY': '觸控螢幕影音',
    'car.equipment.DASH_CAM': '行車紀錄器',
    'car.equipment.REAR_CAMERA': '倒車顯影',
    'car.equipment.TOUCH_SCREEN': '觸控螢幕影音',

    // 退訂政策
    'cancellationPolicy.skeleton.value': '{{0}}未符合條件不退款。',
    'cancellationPolicy.freeCancellation.value':
      '取車日 {{0}} 天前免費取消預約，',
    'cancellationPolicy.percentageCancellation.value':
      '{{0}} 天前取消將退 {{1}}% 的租金，',
    // Mileage policy 相關
    'car.mileagePolicy.limited.text':
      '超過 {{0}} 公里/日, 每公里收取 {{1}} {{2}} 元',
    'car.mileagePolicy.unlimited.text': '不限里程',
    // Fuel policy 相關
    'car.fuelPolicy.FULL_TO_FULL.text': '滿油取還',
    'car.fuelPolicy.SAME_AS_PICK_UP.text': '同取車油量',
    'car.fuelPolicy.CHARGE_BY_DRIVING_MILEAGE.text': '依行駛里程店家現場收費',
    // Payment precaution 相關
    'paymentPrecaution.1.text': '取車時需攜帶個人有效證件(護照/身分證)、取車地國家之合法有效駕照、本次交易的信用卡。',
    'paymentPrecaution.2.text': '如預訂付款的刷卡人非承租人，付款人應攜帶本次交易的信用卡與有效證件(護照/身分證)一同到場取車。',
    'paymentPrecaution.3.text': '若您非取車當地居民，建議您攜帶原居地官方核發駕照+原居地官方核發的國際駕照IDP (詳細規範請參照<a href="https://gogoout.com/about/description">租車說明</a>)。',
    'paymentPrecaution.4.text': '不同國家或特約店家對於文件的要求可能有所不同，建議承租人在租車前務必確認取車地的駕照要求並備妥相關文件。',
    'paymentPrecaution.5.text': '如取車時未能出示取車地國家之合法有效駕照，店內工作人員將拒絕提供租車服務。如遇上述情況，恕不提供任何退款。',

    // Reservation Invoice 相關
    'reservation.detail.invoice.personal.title': '個人',
    'reservation.detail.invoice.company.title': '營業人',
  },
  en: {
    'optionalItem.1.title': 'Guaranteed 2-HR Legal Service',
    'optionalItem.2.title': 'Flexible Cancellation Protection',
    // Payment method 相關
    'paymentMethod.CREDIT_CARD': 'Credit Card',
    'paymentMethod.DEBIT_CARD': 'Debit Card',
    'paymentMethod.LINE_PAY': 'LINE Pay',
    'paymentMethod.AFTEE': 'Aftee',
    'paymentMethod.CASH': 'Cash',
    // Car equipment 相關
    'car.equipment.GPS': 'GPS',
    'car.equipment.ETC': 'ETC',
    'car.equipment.CD_PLAYER': 'CD Player',
    'car.equipment.ADVANCED_AUDIO': 'Advanced Audio',
    'car.equipment.AUX': 'AUX',
    'car.equipment.USB': 'USB Input',
    'car.equipment.BLUETOOTH': 'Bluetooth',
    'car.equipment.CARPLAY': 'CarPlay',
    'car.equipment.DASH_CAM': 'Dash Cam',
    'car.equipment.REAR_CAMERA': 'Rear Dash Cam',
    'car.equipment.TOUCH_SCREEN': 'Touch Screen Audio System',
    // 退訂政策
    'cancellationPolicy.skeleton.value':
      '{{0}} No refund within {{1}} days prior to the pick-up time.',
    'cancellationPolicy.freeCancellation.value':
      'Free cancellation {{0}} days before the pick-up time. ',
    'cancellationPolicy.percentageCancellation.value':
      'Cancellation made before {{0}} days of the pick-up time will refund {{1}}% of the rent fee. ',
    // Mileage policy 相關
    'car.mileagePolicy.limited.text':
      'Exceeding {{0}} km/day, a charge of {{1}} {{2}} per km applies',
    'car.mileagePolicy.unlimited.text': 'Unlimited',
    // Fuel policy 相關
    'car.fuelPolicy.FULL_TO_FULL.text': 'Full to full',
    'car.fuelPolicy.SAME_AS_PICK_UP.text': 'Same as pick up',
    'car.fuelPolicy.CHARGE_BY_DRIVING_MILEAGE.text':
      'Charge by Driving Mileage',
    // Payment precaution 相關
    'paymentPrecaution.1.text': 'Please bring your personal valid ID (passport/ID card), valid driver’s license from the country of pick-up rental car location, and the credit card used for this transaction when picking up the car.',
    'paymentPrecaution.2.text': 'If the person paying with a credit card is not the renter, he/she must also bring the valid ID (passport/ID card) and the credit card used for this transaction when picking up the car.',
    'paymentPrecaution.3.text': 'If you are not a resident of the pick-up location, we recommend bringing your government-issued driver’s license along with an International Driving Permit. For more details, please refer to the <a href="https://gogoout.com/about/description">Rental Statement</a>.',
    'paymentPrecaution.4.text': 'Requirements for documents may vary among different countries or specialized stores. It is recommended that the Lessee check driver’s license requirements from the pick-up location and prepare the relevant documents before renting a car.',
    'paymentPrecaution.5.text': 'If the Lessee fails to present a valid and legal driver’s license required by the pick-up location, the rental company\'s staff will refuse to provide the car rental service. In such a case, no refund will be provided.',

    // Reservation Invoice 相關
    'reservation.detail.invoice.personal.title': 'Individual',
    'reservation.detail.invoice.company.title': 'Company',
  },
  ja: {
    'optionalItem.1.title': 'PAMOのサポート',
    'optionalItem.2.title': 'キャンセル安心保障',
    // Payment method 相關
    'paymentMethod.CREDIT_CARD': 'クレジットカード',
    'paymentMethod.DEBIT_CARD': 'デビットカード',
    'paymentMethod.LINE_PAY': 'LINE Pay',
    'paymentMethod.AFTEE': 'Aftee',
    'paymentMethod.CASH': '現金',
    // Car equipment 相關
    'car.equipment.GPS': 'GPS',
    'car.equipment.ETC': 'ETC',
    'car.equipment.CD_PLAYER': 'CDプレーヤー',
    'car.equipment.ADVANCED_AUDIO': '高級スピーカー',
    'car.equipment.AUX': 'AUX端子',
    'car.equipment.USB': 'USB端子',
    'car.equipment.BLUETOOTH': 'ブルートゥース',
    'car.equipment.CARPLAY': 'CarPlay',
    'car.equipment.DASH_CAM': 'ドライブレコーダー',
    'car.equipment.REAR_CAMERA': '後付け式のドライブレコーダー',
    'car.equipment.TOUCH_SCREEN': 'タッチスクリーン付きオーディオシステム',
    // 退訂政策
    'cancellationPolicy.skeleton.value':
      '{{0}} それ以外は返金対応いたしかねます。 ',
    'cancellationPolicy.freeCancellation.value':
      '乗車日の {{0}} 日まで取消し手数料無料 ',
    'cancellationPolicy.percentageCancellation.value':
      '乗車日の {{0}} 日までの取消しは {{1}}％を返金いたします。',
    // Mileage policy 相關
    'car.mileagePolicy.limited.text':
      '1日あたり{{0}} kmを超えると、1kmごとに{{1}} {{2}}円の料金が発生します。',
    'car.mileagePolicy.unlimited.text': '距離制限なし',
    // Fuel policy 相關
    'car.fuelPolicy.FULL_TO_FULL.text': 'ガソリン満タン返却',
    'car.fuelPolicy.SAME_AS_PICK_UP.text': '受取時と同じガソリンの量',
    'car.fuelPolicy.CHARGE_BY_DRIVING_MILEAGE.text':
      '走行距離によりその場で決済',
    // Payment precaution 相關
    'paymentPrecaution.1.text': 'ピックアップの際には、以下の書類をご持参いただきますようお願い申し上げます。有効な身分証明書（パスポートまたはIDカード）、有効な運転免許証、決済時にご利用いただいたクレジットカード。',
    'paymentPrecaution.2.text': '支払者と運転者が異なる場合について，お手数をお掛けいたしますが、ピックアップの際には以下の書類をご用意いただきますようお願い申し上げます。支払者ご本人の有効な身分証明書（パスポート、IDカードなど）、決済にご利用いただいたクレジットカード、上記書類をお持ちの上、受取地までお越しくださいませ。',
    'paymentPrecaution.3.text': 'ピックアップ場所の居住者でない場合について，お手数をお掛けいたしますが、ピックアップ場所の居住者でない場合は、以下の書類をご携帯いただくことをお勧めいたします：居住国の政府が発行した有効な運転免許証、国際運転免許証（IDP）、詳細な規定につきましては、<a href="https://gogoout.com/about/description">レンタカーのご利用案内</a>をご参照いただけますと幸いです。',
    'paymentPrecaution.4.text': '異なる国や提携店舗では、運転免許証に関する要件が異なる場合がございます。そのため、レンタカーをご利用になる前に、借り手様が車両を受け取る店舗や地域の運転免許証要件をご確認いただきますようお願い申し上げます。また、必要に応じて関連する書類をご準備いただくことをお勧めいたします。',
    'paymentPrecaution.5.text': '車両の引き渡し時に、お受け取り予定の国で有効な運転免許証をご提示いただけない場合、店舗スタッフはレンタカーサービスの提供をお断りする場合がございます。また、このような状況が発生した場合、返金等の対応はいたしかねますので、何卒ご了承くださいますようお願い申し上げます。',

    // Reservation Invoice 相關
    'reservation.detail.invoice.personal.title': '個人',
    'reservation.detail.invoice.company.title': '法人名／代表取締役の氏名',
  },
}

export default translations
